import { render, staticRenderFns } from "./colDetails.vue?vue&type=template&id=868d491a&scoped=true"
import script from "./colDetails.vue?vue&type=script&lang=js"
export * from "./colDetails.vue?vue&type=script&lang=js"
import style0 from "./colDetails.vue?vue&type=style&index=0&id=868d491a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868d491a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('868d491a')) {
      api.createRecord('868d491a', component.options)
    } else {
      api.reload('868d491a', component.options)
    }
    module.hot.accept("./colDetails.vue?vue&type=template&id=868d491a&scoped=true", function () {
      api.rerender('868d491a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financialcenter/reconciliation/colDetails.vue"
export default component.exports